/**
 * XTranslatorDocPage - Renders a documentation page by path.
 * Looks up content from contentMap and displays with DocContent (HTML).
 */
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import Layout from "../components/Layout";
import DocSidebar from "../components/DocSidebar";
import DocContent from "../components/DocContent";
import CONTENT_MAP from "../data/contentMap";

const BASE_PATH = "/docs/x-translator-sw";

export default function XTranslatorDocPage() {
  const { "*": path } = useParams();
  const normalizedPath = path || "1-introduction";

  const content = CONTENT_MAP[normalizedPath];

  if (!content) {
    return <Navigate to={BASE_PATH} replace />;
  }

  return (
    <Layout sidebar={<DocSidebar basePath={BASE_PATH} />} showSidebar={true}>
      <article className="max-w-4xl">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 border-b border-gray-200 dark:border-gray-700 pb-4">
            {content.title}
          </h1>
        </header>
        <DocContent html={content.html} />
      </article>
    </Layout>
  );
}
